/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A Fortnox chart-of-accounts entry, for populating an account picker on invoice forms.
 * @export
 * @interface WebApiIntegrationsDtoFortnoxAccountDto
 */
export interface WebApiIntegrationsDtoFortnoxAccountDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoFortnoxAccountDto
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoFortnoxAccountDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoFortnoxAccountDto interface.
 */
export function instanceOfWebApiIntegrationsDtoFortnoxAccountDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoFortnoxAccountDtoFromJSON(json: any): WebApiIntegrationsDtoFortnoxAccountDto {
    return WebApiIntegrationsDtoFortnoxAccountDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoFortnoxAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoFortnoxAccountDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'number': !exists(json, 'number') ? undefined : json['number'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function WebApiIntegrationsDtoFortnoxAccountDtoToJSON(value?: WebApiIntegrationsDtoFortnoxAccountDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'number': value.number,
        'description': value.description,
    };
}

